import { render, staticRenderFns } from "./VTreemap.vue?vue&type=template&id=f3a38006&"
import script from "./VTreemap.vue?vue&type=script&lang=js&"
export * from "./VTreemap.vue?vue&type=script&lang=js&"
import style0 from "./VTreemap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports